<template>
    <div class="vx-row mb-4">
        <div class="vx-card p-2 text-center">
            <div class="vx-row">
                <div class="w-full md:w-1/3 m-auto">
                    <div class="component w-full">
                        <span class="font-bold" style="font-size:16px">Đang ở chế độ dùng thử</span>
                    </div>
                    <div class="component w-full cursor-pointer">
                        <feather-icon icon="XIcon" class="text-danger cancel-trial"></feather-icon>
                        <span class="text-danger ml-1" @click="cancelTrial">Thoát dùng thử</span>
                    </div>
                </div>
                <div class="mr-4 mt-1 create-topic">
                    <vs-button icon-pack="feather" icon="icon-plus" @click="createTopic">Tạo nhanh chủ đề</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        topicId: null,
    },
    data(){
        return {
            topic: {}
        }
    },
    methods: {
        cancelTrial: function(){
            localStorage.removeItem('dataTrial');
            location.reload();
        },
        createTopic: function(){
            if (!this.topicId) {
                return this.$vs.notify({
                    text: 'Chưa chọn chủ đề tạo mới nhanh',
                    icon: "icon-alert",
                    iconPack: "feather",
                    color: "danger"
                });
            }
            if (!this.topicId) {return}
            this.$business.get(`topic/find-by-id/${this.topicId}`).then((res) => {
                this.topic = res.data;
                 this.$business.post('/topic/create', this.topic).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                    color: 'primary',
                    text: `${this.$t('projectAndTopic.add')} ` + ` ${this.$t('projectAndTopic.textAdd')} ` + `${this.topic.topicName}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    });
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                    });
                });
            })
        }
    }
}
</script>

<style scoped>
.cancel-trial {
    width: 15px;
    vertical-align: middle;
}
.create-topic {
    position: absolute;
    right: 0;
    top: 10px;
}
</style>